import { render } from "./BlockEditor.vue?vue&type=template&id=753141ee&scoped=true"
import script from "./BlockEditor.vue?vue&type=script&lang=js"
export * from "./BlockEditor.vue?vue&type=script&lang=js"

import "./BlockEditor.vue?vue&type=style&index=0&id=753141ee&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753141ee"]])

export default __exports__